import React, { useState } from "react";
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes, FaHome } from 'react-icons/fa';

function NavBar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <NavLink exact to="/" className="navbar-logo-link" onClick={closeMobileMenu}>
          <FaHome size={30} />
        </NavLink>

        <div className="nav-icon" onClick={handleClick}>
          {click ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <NavLink
              exact
              to="/"
              className={({ isActive }) => "nav-links" + (isActive ? " active" : "")}
              onClick={closeMobileMenu}
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              exact
              to="/blog"
              className={({ isActive }) => "nav-links" + (isActive ? " active" : "")}
              onClick={closeMobileMenu}
            >
              Blog
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              exact
              to="/project"
              className={({ isActive }) => "nav-links" + (isActive ? " active" : "")}
              onClick={closeMobileMenu}
            >
              Projects
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              exact
              to="/connect"
              className={({ isActive }) => "nav-links" + (isActive ? " active" : "")}
              onClick={closeMobileMenu}
            >
              Connect
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;


